export const SystemStatusEnum = {
  Activated: 'Activated',
  Deactivated: 'Deactivated',
  Banned: 'Banned',
};
